export enum EnumFrameOutcome {
  APPLIED = 'applied',
  DUPLICATE = 'duplicate',
  FOREIGN = 'foreign',
  INVALID = 'invalid',
  AFTER_TERMINAL = 'afterTerminal'
}
